/**
 * Letter from the founding team — Luminous Atrium treatment.
 * Cream paper card, soft rounded language, Instrument Sans body
 * with restrained Instrument Serif italic accents.
 */
export const EditorialFounderLetter = () => {
  return (
    <section
      aria-labelledby="founder-letter-title"
      className="px-4 sm:px-5 md:px-10 py-12 sm:py-20 md:py-28"
    >
      <div className="max-w-3xl mx-auto">
        <div className="relative rounded-[24px] sm:rounded-[28px] md:rounded-[36px] bg-card/90 backdrop-blur-sm border border-border/60 shadow-[0_24px_60px_-32px_rgba(62,92,77,0.18)] p-6 sm:p-10 md:p-16">
          {/* Eyebrow */}
          <div className="flex items-center gap-3 mb-7 md:mb-9">
            <span className="inline-flex h-2 w-2 rounded-full bg-primary" />
            <span className="font-sans text-[11px] uppercase tracking-[0.22em] font-medium text-muted-foreground">
              A note from the founding team
            </span>
          </div>

          {/* Headline */}
          <h2
            id="founder-letter-title"
            className="font-sans text-[26px] sm:text-4xl md:text-[44px] leading-[1.12] tracking-[-0.02em] font-medium text-foreground mb-7 md:mb-12 max-w-[22ch]"
          >
            Why we built a channel,{" "}
            <span className="font-serif italic font-normal text-primary">
              not a survey.
            </span>
          </h2>

          {/* Body */}
          <div className="font-sans text-[15.5px] md:text-[17px] text-foreground/85 leading-[1.7] md:leading-[1.75] space-y-4 md:space-y-6">
            <p>
              <span className="font-serif italic font-normal text-primary text-[44px] sm:text-[56px] md:text-[64px] float-left leading-[0.85] mr-2 sm:mr-3 mt-1.5 sm:mt-2">
                I
              </span>
              spent six years inside HR teams watching the same scene play out:
              a top performer resigns, the leadership team is{" "}
              <span className="italic font-serif">&ldquo;blindsided&rdquo;</span>,
              and somewhere in a drawer is an engagement survey from three
              months ago saying everything is fine.
            </p>
            <p>
              It wasn&rsquo;t fine. It was never fine. People just weren&rsquo;t
              going to write the truth into a form that asked for their name,
              their team, and their employee ID at the top.
            </p>
            <p>
              We built SendFeedback for the People leader who already knows this
              &mdash; and who is tired of being the last to find out. No logins.
              No metadata. No backdoor.{" "}
              <span className="text-foreground font-medium">
                Just the channel your team has been waiting for someone to open.
              </span>
            </p>
          </div>

          {/* Signature */}
          <div className="mt-10 md:mt-14 pt-7 md:pt-9 border-t border-border/60 flex items-end justify-between gap-6">
            <div>
              <div className="font-serif italic text-xl md:text-2xl text-foreground leading-tight">
                The founding team
              </div>
              <div className="font-sans text-[11px] uppercase tracking-[0.22em] font-medium text-muted-foreground mt-2">
                SendFeedback &middot; London
              </div>
            </div>
            <svg
              viewBox="0 0 200 60"
              className="h-10 md:h-12 text-primary/70 flex-shrink-0"
              aria-hidden
            >
              <path
                d="M5 38 C 18 8, 32 50, 48 22 S 78 50, 96 18 C 110 -2, 130 48, 152 24 C 168 8, 184 36, 196 18"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
              />
            </svg>
          </div>
        </div>
      </div>
    </section>
  );
};
